module.exports = __webpack_public_path__ + "static/media/staff_Christy.3b7257d7.svg";